const Base = {
  "projectorTypes": {
    "Standard-Throw": {
      "Bright": {
        "DW3": {
          "r169": {
            "Black": {
              "92": [{ "30": ["43533145800970"] }],
              "100": [{ "30": ["43533145833738"] }],
              "110": [{ "30": ["43533145866506"] }],
              "120": [{ "30": ["43533145899274"] }],
              "135": [{ "30": ["43533145932042"] }]
            }
          }
        },
       
          
          
        
      },
        "Dark": {
        "DW3": {
          "r169": {
            "Black": {
              "92": [{ "30": ["43533145800970"] }],
              "100": [{ "30": ["43533145833738"] }],
              "110": [{ "30": ["43533145866506"] }],
              "120": [{ "30": ["43533145899274"] }],
              "135": [{ "30": ["43533145932042"] }]
            }
          }
        },
       
          
          
        
      }
    }
  }
};
  
var selection={
    "Beamer":'Standard-Throw',
    "Ambience":'Dark',
    "Material":'DW3',
    "Aspect":'r169',
    "CaseColor":'Black',
    "Size":100,
    "TopDrop":30,
    "ProdVariant":"43533145833738",
}

/*
document.getElementById('testAvCall').addEventListener("click", function() {
  // Hier kommt die Funktion, die beim Klick ausgeführt wird
  var testAr = Object.keys(Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor]);
  console.log(testAr);
  var testqueste = Object.keys(Base[selection.Beamer]?.[selection.Ambiance]?.[selection.Material]?.[selection.Aspect]?.[selection.CaseColor] || {});
  console.log(testqueste);
});
*/

function showMip(){
  return Base[selection.Beamer]?.[selection.Ambiance]?.[selection.Material]?.[selection.Aspect]?.[selection.CaseColor] || {};
}


  function selectBeamer(){
    selection.Beamer= $(this).attr("id");
   console.log(selection.Beamer);
  }

  /*
const CLR = document.getElementById("CLR");
const AcousticPro = document.getElementById("AcousticPro");
const MaxWhite = document.getElementById("MaxWhite");
const Cinegrey = document.getElementById("Cinegrey");
*/

const r169 = document.getElementById("r169");
var avMaterials;

document.getElementById("Bright").addEventListener("click",setAmbiance);
document.getElementById("Dark").addEventListener("click",setAmbiance);

//document.getElementById("resetFilter").addEventListener("click",resetFilter);

/*
function resetFilter(){
  CLR.style.display="inline-flex"
  AcousticPro.style.display="inline-flex"
  MaxWhite.style.display="inline-flex"
  Cinegrey.style.display="inline-flex"
} */

document.querySelector('.model-div').addEventListener('wheel', function(event) {
    event.preventDefault();
}, { passive: false });

function setAmbiance(){
  selection.Ambience= $(this).attr("id");
  getMaterials();
} 

const buttons = [ "DW3"];
const ratio = {r169 };

function getMaterials(){
    
   // BEFORE AMB. 
   // var avMaterials = Object.keys(Base.projectorTypes[selection.Beamer].materials);
   console.log(Base.projectorTypes[selection.Beamer]);
   console.log(Base.projectorTypes["Standard-Throw"]);
     console.log(Base.projectorTypes["Standard-Throw"]["Dark"]);
     console.log(selection);
    avMaterials = Object.keys(Base.projectorTypes[selection["Beamer"]][selection["Ambience"]]);
    console.log(avMaterials);
    hideUI();

    // Alle verfügbaren Materialien angeben!
   
// Schleife durch die verfügbaren Materialien
for (const button of buttons) {
  if (avMaterials.includes(button)) {
    const el = document.getElementById(button);
    if (el) {
      el.style.display = "inline-flex"; // Anzeigen
    }
  }
} }

function getRatios(){

  var avRatios = Object.keys(Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material]);
  console.log(avRatios);

  r169.style.display="none";
 

  for (const key in ratio) {
    console.log(key);
    console.log();
    if (avRatios.includes(key)) {
      
        ratio[key].style.display = ""; // Anzeigen
    }
}
}





function hideUI(){
 document.querySelectorAll(".buttonMat").forEach(btn => {
  btn.style.display = "none";
});
}



var  formData ={
  'items': [ {
    'id': 43533160710410,
    'quantity': 1
     
    } ]
};
document.getElementById("addCart").addEventListener("click", addItems1);


function addItems1() {
    //console.log("additem " + selection.ProdVariant );
  formData.items[0].id=selection.ProdVariant;
    //console.log("formData: "+ JSON.stringify(formData, null, 2))
  
// fügt in den Cart JS hinzu
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },



  
  body: JSON.stringify(formData)
})
.then(response => {
  return response.json();
})
.catch((error) => {
  console.error('Error:', error);
});

  

  console.log("Added");

 
setTimeout(() => {
    window.location.href = `${window.location.origin}/cart`;
}, "1000");



}


/*
function addItems1() {
  formData.items.id = selection.ProdVariant;

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    console.log('Produkt hinzugefügt:', data);

    // Danach die SECTIONS holen
    fetch(window.Shopify.routes.root + '?sections=cart-drawer')
      .then(response => response.json())
      .then(parsedState => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          if (typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(parsedState); // <== Jetzt parsedState
          } else {
            console.warn('cartDrawer hat keine renderContents-Methode!');
          }

          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        } else {
          console.warn('Kein cart-drawer gefunden!');
        }
      });
  })
  .catch((error) => {
    console.error('Error:', error);
  });

  fetch(window.Shopify.routes.root + '?sections=cart-drawer')
  .then(response => response.json())
  .then(parsedState => {
    console.log('Sections Response:', parsedState); // <-- hier
    
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      if (typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState);
      } else {
        console.warn('cartDrawer hat keine renderContents-Methode!');
      }

      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    } else {
      console.warn('Kein cart-drawer gefunden!');
    }
  });
  
}

/*
function bC(){

  console.log("BC");
  
  document.dispatchEvent(new CustomEvent('cart:build'));

  document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: formData,
            addToCartBtn: this.addToCart
          }
        }));
}
*/





//// Babylon Render Engine 
var slider = document.getElementById("myRange");
var slider2 = document.getElementById("myRange2");

       const sliderheight = document.getElementById("screenheight");
        var sliderheightVal = document.getElementById("screenheightspan");

        var roomnotice = document.getElementById("notice");
        var slidercol3 = document.getElementById("sliderfiller3");


/*var output = document.getElementById("demo");
output.innerHTML = slider.value; // Display the default slider value
*/



var values169;
var values1610;
var values219;
var resFactorX = 1;
var resFactorY = 1;

var leinwandmesh4;
//var shebeammesh;
//var shbeammermesh;


    const button3d = document.getElementById("3db");

if (button3d) {
  button3d.addEventListener("click", showOnly);
  
}
          
                  document.getElementById("close").addEventListener("click", closeModal);

      const sections = document.querySelectorAll('section');
 var sections1 = document.getElementsByClassName("shopify-section");

  $('.togglebutton').click(function() {
  const $btn = $(this);
  const $panel = $btn.next('.panel'); // nächstes Geschwister-Element
   
  $panel.toggleClass('closed'); // Panel ein-/ausfahren
  $btn.find('.chevron').toggleClass('rotate'); // Chevron drehen
});


function showOnly() {

  for(i=0;i<sections1.length;i++){
    sections1[i].style.display="none";
  }

  // Alle <section>-Elemente ausblenden
  sections.forEach(section => {
    section.style.display = 'none';
  });


  // Das gewünschte Div einblenden
  const selectedDiv = document.getElementById("shopify-section-template--27694827176202__saker_tt_3_d_VERdme");
  if (selectedDiv) {
    selectedDiv.style.display = 'block'; // Das gewählte Div sichtbar machen
    document.getElementById("3dconfig").style.display="block";
    console.log("showonly clicked");
  }

  //newParent.appendChild(priceTags);
  
  startRender();
engine.resize();
  

       //startRender();
         window.scrollTo({
        top: 0,
        behavior: "smooth" // smooth scroll, optional
    });

}

        function closeModal() {
   //

  for(i=0;i<sections1.length;i++){
    sections1[i].style.display="";
  }

  // Alle <section>-Elemente ausblenden
  sections.forEach(section => {
    section.style.display = '';
  });


  // Das gewünschte Div einblenden
  const selectedDiv = document.getElementById("shopify-section-template--27694827176202__saker_tt_3_d_VERdme");
  if (selectedDiv) {
    selectedDiv.style.display = 'none'; // Das gewählte Div sichtbar machen
    document.getElementById("3dconfig").style.display="none";
  }
          //oldParent.appendChild(priceTags);
        }
      


/*
  // Alle Elemente im body auswählen
  const allDivs = document.querySelectorAll('body > *');

  allDivs.forEach(div => {
    if (div.id !== '3dconfig') {
      div.style.display = 'none'; // Alle ausblenden, außer das mit der ID '3dconfig'
    }
  });

  // Das gewählte Div einblenden
  const selectedDiv = document.getElementById("3dconfig");
  if (selectedDiv) {
    selectedDiv.style.display = 'block'; // Das gewählte Div einblenden
  }*/


  



const canvas = document.getElementById("renderCanvas"); // Get the canvas element
      const engine = new BABYLON.Engine(canvas, true); // Generate the BABYLON 3D engine

engine.setHardwareScalingLevel(1 / window.devicePixelRatio);

      // Add your code here matching the playground format
      const createScene = function () {
        const scene = new BABYLON.Scene(engine);

      const empty = new BABYLON.TransformNode("emptyParent", scene);
        empty.position.y=2.25;
      
    




       
        //const hdrTexture = BABYLON.CubeTexture.CreateFromPrefilteredData("https://assets.babylonjs.com/environments/environmentSpecular.env", scene);
        //scene.environmentTexture = hdrTexture;
        var standardbeambool = false;
        var shortbeambool = false;

        function sleep(ms) {
          return new Promise(resolve => setTimeout(resolve, ms));
        }
   
         values169 = [92, 100, 110, 120, 135];
      

        var topDrops=[30,60];

        
        var oldInd=100;
        var newInd=100;

        var nextpos;

        let debounceTimeout;
      
        
        const sliderValue = document.getElementById('sliderLabel');
        const sliderValue2 = document.getElementById('sliderLabel2');
        const sliderValue3 = document.getElementById('sliderLabel3');

     
       
       
       
       


   
       
        var nearestTopDrop = 30;

      
        
     

      

       
var titleRecap;

        function getPrice(){
          var currentId= Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][selection.Size].find(item => item[selection.TopDrop])?.[selection.TopDrop][0];
          selection.ProdVariant=currentId;
           const price = getPriceById(meta, Number(currentId));
                console.log(titleRecap);
            console.log(price);
       var   formattedPrice = (price / 100).toLocaleString("de-DE", { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
});
   
         console.log(formattedPrice);
         pricehtml.innerHTML = "€"+String(formattedPrice)+" EUR";
         confightml.innerHTML= String(titleRecap);
         
checkVariantAvailability(selection.ProdVariant);     
        }
        
        function getPriceById(product, variantId) {
    const variant = product.product.variants.find(v => v.id === variantId);
          titleRecap = variant.public_title
    return variant ? variant.price : null; 
}

   

       var pricehtml = document.getElementById( "pricehtml");
        var confightml = document.getElementById( "confightml");
        
    



        

       

                const tickContainer = document.querySelector('.slider-ticks');


      function getSizes(){

      

        tickContainer.innerHTML = "";
        
        var avSizes = Object.keys(Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor]);
        console.log(selection);
        console.log("avSizes: "+avSizes);
        values169= avSizes;
      
       //slider2 = document.getElementById("myRange2");
       slider2.min=avSizes[0];
       slider2.max=avSizes[avSizes.length - 1 ]; 

        
       avSizes.forEach(val => {
  const span = document.createElement('span');
  span.textContent = "'";

  // Position in Pixeln berechnen
  const ratio = (val -  slider2.min) / (slider2.max -  slider2.min);
  const posPx = ratio * 346;

  
  span.style.left = `${posPx}px`;

  if(ratio==0){
    span.style.left = `5px`;
  }

  tickContainer.appendChild(span);
});
  

        
       const nearestValue = _.minBy(avSizes, (value) => Math.abs(value - oldInd));
        
       //topDrops = Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][nearestValue];
        //console.log(topDrops);
 selection.Size = nearestValue;
newInd = Number(nearestValue);


if(selection.Aspect=="r169"){
  console.log("inside ratiuos 169");
       slider2.value=nearestValue;
       sliderValue.innerHTML=nearestValue;

       sliderWidth = slider2.offsetWidth;  // Breite des Sliders
     labelWidth = sliderValue.offsetWidth; // Breite des Labels
     newLeft = ((slider2.value - slider2.min) / (slider2.max - slider2.min)) * sliderWidth - (labelWidth / 2);

     sliderValue.style.left = `${newLeft}px`;

       if(newLeft<=0){
         slidercol.style.width="10px"
                  sliderValue.style.left =`-4px`;

         }else{
          slidercol.style.width=`${newLeft}px`;
         }
        
    // Setze die neue Position des Labels
    
       
        }

  

  
       //oldInd=newInd;
      
       
        //slider2.dispatchEvent(new Event('input'));

        overallScale();

      

      }


     
   


            document.getElementById("r169").addEventListener("click", changeScale169 );

              function changeScale169(){

                resFactorX =1;
                resFactorY = 1;

              document.getElementById("res169").style.display="block";
              
            document.getElementById("res219").style.display="none";
              document.getElementById("res1610").style.display="none";
              selection.Aspect="r169";

              $("#r169").prop('disabled', true);
      

                    $("#r169").css({
                      "background-color": "white",
                      "border-color": "#0071e3",
                      "border-width": "2px"
                  });

        

   $('.buttonMat').prop('disabled', false).css({
    "background-color": "white",
    "cursor": "pointer"
});
            

            

   

              
              getSizes();
             
              
              //newInd= 120; 
                  //scale169();
            //  overallScale();
            
          /*    setTimeout(() => {
 
    console.log("Beide Funktionen wurden aufgerufen.");
}, 1000); */
                
              }
  
              async function overallScale(){

 if(oldInd <= newInd){
              for (let i = oldInd; i <= newInd; i++) {   
              
              leinwandmesh1.scaling = new BABYLON.Vector3(resFactorX*(i/100),resFactorY*(i/100),1);

              RahmenL.position.x = (-1.11-((i*resFactorX)-100)*0.0112);
              RahmenR.position.x = (1.11+((i*resFactorX)-100)*0.0112);        
              RahmenL.scaling = new BABYLON.Vector3(1,resFactorY*((i*2.21)/216),1);
              RahmenR.scaling= new BABYLON.Vector3(1, resFactorY*((i*2.21)/216),1);
              
             
           
              RahmenU.position.y = (0-((i*resFactorY)-100)*0.01255);
              RahmenO.scaling = new BABYLON.Vector3(((i*2.21)/216)*resFactorX,1,1);
              RahmenU.scaling= new BABYLON.Vector3(((i*2.21)/216)*resFactorX,1,1);

              Rückseite.scaling= new BABYLON.Vector3(i/100*resFactorX,i/100*resFactorY,1);

              KappeOL.position.x =  (RahmenL.position.x+1.108)
              KappeOR.position.x = (RahmenR.position.x-1.108)

              KappeUL.position = new BABYLON.Vector3((RahmenL.position.x+1.108),RahmenU.position.y,0);
              KappeUR.position =  new BABYLON.Vector3((RahmenR.position.x-1.108),RahmenU.position.y,0);

              Logo.position.x=(0.856+((i*resFactorX)-100)*0.0112);
              Logo.position.y=(-1.253-((i*resFactorY)-100)*0.01255);

          //leinwandmesh.rotation = new BABYLON.Vector3(0,3.14,0);



                      await sleep(30);       
            }}else if(oldInd > newInd){   
            
              for (let i = oldInd; i > newInd; i--) {                                                      
                       leinwandmesh1.scaling = new BABYLON.Vector3(resFactorX*(i/100),resFactorY*(i/100),1);

              RahmenL.position.x = (-1.11-((i*resFactorX)-100)*0.0112);
              RahmenR.position.x = (1.11+((i*resFactorX)-100)*0.0112);        
              RahmenL.scaling = new BABYLON.Vector3(1,resFactorY*((i*2.21)/216),1);
              RahmenR.scaling= new BABYLON.Vector3(1, resFactorY*((i*2.21)/216),1);
              
             
           
              RahmenU.position.y = (0-((i*resFactorY)-100)*0.01255);
              RahmenO.scaling = new BABYLON.Vector3(((i*2.21)/216)*resFactorX,1,1);
              RahmenU.scaling= new BABYLON.Vector3(((i*2.21)/216)*resFactorX,1,1);

              Rückseite.scaling= new BABYLON.Vector3(i/100*resFactorX,i/100*resFactorY,1);

              KappeOL.position.x =  (RahmenL.position.x+1.108)
              KappeOR.position.x = (RahmenR.position.x-1.108)

              KappeUL.position = new BABYLON.Vector3((RahmenL.position.x+1.108),RahmenU.position.y,0);
              KappeUR.position =  new BABYLON.Vector3((RahmenR.position.x-1.108),RahmenU.position.y,0);

              Logo.position.x=(0.856+((i*resFactorX)-100)*0.0112);
              Logo.position.y=(-1.253-((i*resFactorY)-100)*0.01255);
           // leinwandmesh.rotation = new BABYLON.Vector3(0,3.14,0);
                      await sleep(30);    
            }

           
            }
       

            oldInd=newInd;
            //console.log("post scale169: " +"oldInd:"+oldInd+"newInd: "+newInd);
            //checkColorAv();

               
            if(roombool){

            
          if(selection.Aspect==="r169"){
          checkSize(newInd,16,9);}
       
        

          console.log("HÖHE:" + (gesamthöhe) + "Breite: " + screenwidth)
          if(gesamthöhe>roomHeight.value ){
              console.log("CLIP HEIGHT");
          } 
            if(screenwidth > roomWidth.value){
            console.log("WIDTH HEIGHT");
          }

          //vom Boden
          if((empty.position.y-(gesamthöhe*0.01))<0){
              console.log("CLIP CHANGE SLIDERVAL");
              empty.position.y = 0.01*(gesamthöhe+10);
               screenheightgui(gesamthöhe+10);
              console.log("HERESLIDERHEIGHT" + sliderheight.value);
            }
            
            // Positioniere LW immer an oberster position 
            if((empty.position.y+20>(roomHeight.value*0.01))){
              //console.log("ZU GROß MACH KLEIN");
              empty.position.y = 0.01*(roomHeight.value-20);
              screenheightgui(roomHeight.value-20);
              //console.log("HERESLIDERHEIGHT" + sliderheight.value);
            }
        
              checkScreensize();
          }
              getPrice();

              }

      


        

  


          //Gehäuse
           var gehäusemesh = BABYLON.AbstractMesh;
          var leinwandmesh = BABYLON.AbstractMesh;
          var leinwandmesh1 = BABYLON.AbstractMesh;
       

          var RahmenL;
          var RahmenR;
          var RahmenO;
          var RahmenU;
          var Rückseite;
          var KappeOL;
          var KappeOR;
          var KappeUL;
          var KappeUR; 
          var Logo;

     


        
        leinwandtuch = BABYLON.SceneLoader.ImportMesh("", "https://cdn.shopify.com/3d/models/6110fea34446dafd/", "Configurator-DayWalker-Framed.glb", scene, function(newMeshes){
            leinwandmesh= newMeshes[0];
           //leinwandmesh1= newMeshes[19];

           leinwandmesh1= scene.getMeshByName("Leinwand.001");


           /*leinwandmesh2= newMeshes[3];
           leinwandmesh4= newMeshes[1];
          leinwandmesh5= newMeshes[0];
            gehäusemesh= newMeshes[0];*/
            
             /* gehäusemesh.setParent(empty);
            leinwandmesh.setParent(empty);
           leinwandmesh1.setParent(empty);
           leinwandmesh2.setParent(empty);
          leinwandmesh4.setParent(empty);*/

          //leinwandmesh4.scaling.y = 1;
          //leinwandmesh4.rotation = new BABYLON.Vector3(0, 0, 0);
       //   console.log(leinwandmesh4.position.y);


                    RahmenL = scene.getMeshByName("Edge L"); // Beispielname fuer Sitzelement
                    RahmenR = scene.getMeshByName("Edge R"); // Beispielname fuer Sitzelement
                    RahmenO = scene.getMeshByName("Edge O");
                    RahmenU = scene.getMeshByName("Edge U");
                    Rückseite = scene.getTransformNodeByName("Rückseite-LW.001");

                    KappeOL = scene.getMeshByName("Kappe O-l.001");
                    KappeOR = scene.getMeshByName("Kappe O-R.001");
                    KappeUL = scene.getMeshByName("Kappe U-l.001");
                    KappeUR = scene.getMeshByName("Kappe U-R.001");

                    Logo = scene.getMeshByName("Plane.001");

                    leinwandmesh.setParent(empty, true);

               

         document.querySelectorAll(".buttonMat").forEach(btn => btn.addEventListener("click", changeMat));


          function changeMat(){
            console.log("click");

            BABYLON.GLTF2.Loader.Extensions.KHR_materials_variants.SelectVariant(leinwandmesh,$(this).attr("id"));
            selection.Material=$(this).attr("id");
            if(selection.Material=="CLR"){
            
            }

          
           
        document.querySelectorAll(".buttonMat").forEach(btn => btn.disabled = false);

        $(this).prop('disabled', true);
        
        document.querySelectorAll(".buttonMat").forEach(btn => {
  btn.style.backgroundColor = "";
  btn.style.borderColor = "";
  btn.style.borderWidth = "";
});
        $(this).css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });

     
           
            getRatios();
           
            console.log("before getsizes");
            getSizes();    
            console.log("after getsizes");
        
            
     
            
         

            
      
    
          


            console.log(selection);
          }
       });
          

       var i;


         function screenheightgui(v){


        const newLeft4 = parseInt(((v - sliderheight.min) /(sliderheight.max - sliderheight.min))*300) ;
        slidercol3.style.width=`${newLeft4}px`;
          sliderheightVal.style.left =`${newLeft4}px`;
          sliderheightVal.innerHTML=v;

       }

        sliderheight.oninput = function(){
          console.log("slider");
          empty.position.y= (0.01*(sliderheight.value)); //.8

    
        sliderheightVal.innerHTML= parseInt(sliderheight.value) ;
        screenheightgui(sliderheight.value);

         
        }

              var slidercol = document.getElementById("sliderfiller");
        var slidercol2 = document.getElementById("sliderfiller2");
       var slidercol4 = document.getElementById("sliderfiller4");

       slider2.oninput = function() {
         i = Number(slider2.value);
         sliderValue.innerHTML = i;
         
         oldInd= i;
     
     //   console.log("I: "+i);

         const sliderWidth = this.offsetWidth;
           const labelWidth = sliderValue.offsetWidth;
           const newLeft = ((i - this.min) / (this.max - this.min)) * sliderWidth - (labelWidth / 2);
           //console.log(newLeft);

           sliderValue.style.left =`${newLeft}px`;

          if(newLeft<=0){
         slidercol.style.width="10px"
                  sliderValue.style.left =`-4px`;

         }else{
          slidercol.style.width=`${newLeft}px`;
         }

           gehäusemesh.rotation = new BABYLON.Vector3(0, 0, 0);
        
               leinwandmesh1.scaling = new BABYLON.Vector3(i/100,i/100,1);
                
              RahmenL.position.x = -1.11-(i-100)*0.0112;
              RahmenR.position.x = 1.11+(i-100)*0.0112;
              RahmenL.scaling = new BABYLON.Vector3(1,((i*2.21)/216),1);
              RahmenR.scaling= new BABYLON.Vector3(1,((i*2.21)/216),1);

               KappeOL.position.x =  RahmenL.position.x+1.108
               KappeOR.position.x = RahmenR.position.x-1.108

            

              RahmenU.position.y = 0-(i-100)*0.01255;
              RahmenO.scaling = new BABYLON.Vector3(((i*2.21)/216),1,1);
              RahmenU.scaling= new BABYLON.Vector3(((i*2.21)/216),1,1);

               KappeUL.position = new BABYLON.Vector3(RahmenL.position.x+1.108,RahmenU.position.y,0);
               KappeUR.position =  new BABYLON.Vector3(RahmenR.position.x-1.108,RahmenU.position.y,0);

               Logo.position.x=0.856+(i-100)*0.0112;
               Logo.position.y=-1.253-(i-100)*0.01255;

              Rückseite.scaling= new BABYLON.Vector3(i/100,i/100,1);

               //leinwandmesh2.scaling = new BABYLON.Vector3(i/100,i/100,1);
               //leinwandmesh4.scaling = new BABYLON.Vector3(i/100,i/100,1);


         //leinwandmesh.rotation = new BABYLON.Vector3(0,3.14,0);
              
               //leinwandmesh2.rotation = new BABYLON.Vector3(0, 0, 0);
              //leinwandmesh4.rotation = new BABYLON.Vector3(0, 0, 0);
              //leinwandmesh5.rotation = new BABYLON.Vector3(0, 0, 0);
         
               



         
               
              

            
             
                
               const nearestValue = _.minBy(values169, (value) => Math.abs(value - i));
               console.log(values169);
               console.log(i);
       newInd= nearestValue;
         selection.Size = nearestValue;
        console.log("nearesT: "+ nearestValue);

 
               //oldInd = i;
               //sliderValue.innerHTML = newInd;
               
       clearTimeout(debounceTimeout);
       debounceTimeout = setTimeout( function() {
         
         
         
         const newLeft = ((newInd - values169[0]) / ((values169[values169.length - 1]) -values169[0])) * sliderWidth - (labelWidth / 2);
        //console.log(newLeft);
        slider2.value=newInd;
        sliderValue.innerHTML = newInd;
         sliderValue.style.left =`${newLeft}px`;

           if(newLeft<=0){
         slidercol.style.width="10px"
                  sliderValue.style.left =`-4px`;

         }else{
          slidercol.style.width=`${newLeft}px`;
         }

         //console.log("SLIDER 2 ");
         //console.log("Slidertest "+"Nearest:"+nearestValue+"oldInd"+oldInd+"newInd"+newInd);
        
         
         //scale169();
        overallScale();
        
         
         
  
         
         
         

     }, 100); // Verzögerung von 300ms //
               
    

     }

       
      

       
     
      
      

        const camera = new BABYLON.ArcRotateCamera("camera", -Math.PI / 2, Math.PI / 2.5, 15, new BABYLON.Vector3(0, 0, 0));
        camera.attachControl(canvas, true);
        camera.setPosition(new BABYLON.Vector3(0, -0.5,4));
        camera.target = new BABYLON.Vector3(0 ,-0.75,0);
        const light = new BABYLON.HemisphericLight("light", new BABYLON.Vector3(0, 1, 1));

         const pointLight = new BABYLON.PointLight("point", new BABYLON.Vector3(0, 0, -5), scene);
        pointLight.intensity = 0.4;
        
      
        camera.wheelPrecision = 70;
        camera.lowerRadiusLimit=1;
        camera.minZ = 0;

       var bGchange = document.getElementById("mainelement");

        
      // Füge die Animation der Kamera hinzu
      document.getElementById("Dark").addEventListener("click",async () => {


      
        $("#Dark").prop('disabled', true);
        $("#Bright").prop('disabled', false);

        $("#Bright").css({
          "background-color": "",
          "border-color": "",
          "border-width": ""
      });

        $("#Dark").css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });
       
   

        for(let i=1; i< 25; i++){
          var cVal = 100-i;
          scene.clearColor = new BABYLON.Color4(cVal/100, cVal/100, cVal/100, 1);
          bGchange.style.background = "rgb(" + cVal + "% " + cVal + "% " + cVal + "%)";

           if(roombool){
          wallMaterial.specularPower = 2.56*i;
          } 
          pointLight.intensity = 0.4-(0.016*i); 
          
          await sleep(10); 

        }



      });

      document.getElementById("Bright").addEventListener("click",async () => {

      //var buttony=  console.log(Base[selection.Beamer][selection.Ambiance][0])

        const event = new Event("click", { bubbles: true, cancelable: true });
        document.getElementById(avMaterials[0]).dispatchEvent(event);

        $("#Bright").prop('disabled', true);
        $("#Dark").prop('disabled', false);


        $("#Dark").css({
          "background-color": "",
          "border-color": "",
          "border-width": ""
      });

        $("#Bright").css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });

        

    

        for(let i=1; i< 25; i++){
          var cVal2 = 75+i
          scene.clearColor = new BABYLON.Color4(cVal2/100, cVal2/100, cVal2/100, 1);         
          bGchange.style.background = "rgb(" + cVal2 + "% " + cVal2 + "% " + cVal2 + "%)";
          if(roombool){
            wallMaterial.specularPower = 64-(2.56*i);
                    }
          pointLight.intensity = 0.016*i;
          await sleep(10); 

        }

      });
     
     /* document.getElementById("removebeamer").addEventListener("click",removeB);

      function removeB(){
        camera.setPosition(new BABYLON.Vector3(0, -1,4));
        camera.target = new BABYLON.Vector3(0 ,-0.5,0);
        if(shortbeambool){
          shbeamermesh.dispose();
        shbeammesh.dispose();
        shortbeambool = false;
        }else if(standardbeambool){
          if(standardbeambool){
            stbeamermesh.dispose();
          stbeammesh.dispose();
          standarbeambool = false;
          }
        }
      } */

        //Beamer
       document.getElementById("Standard-Throw").addEventListener("click",selectStandardBeamer);

       function selectStandardBeamer(){
        console.log("NewInd:"+ newInd+"oldInd: "+ oldInd);
        selection.Beamer= $(this).attr("id");
        console.log($(this).attr("id"));
     

       
        $("#Standard-Throw").prop('disabled', true);
       
        
     

        $(this).css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });
        

        
    //    console.log(selection.Beamer);
        getMaterials();
        
      const event = new Event("click", { bubbles: true, cancelable: true });
        document.getElementById(avMaterials[0]).dispatchEvent(event);
        
      /*  if(shortbeambool){
          shbeamermesh.dispose();
        shbeammesh.dispose();
        }
*/
        standardbeambool = true;
        shortbeambool = false;

        changeScale169();

       }
      



      //ROOMSTART

        //getSizes();
  //ROOM

          var mainWall; 
    var roombool;
         var wallMaterial;

    function createRoom(){
         $('#roomgui').addClass('panel');
          $('#roomgui').removeClass('roomguic');
 document.getElementById("createRoom").style.display="none";
      
      roombool=true;
      if(selection.Aspect==="r169"){
          checkSize(newInd,16,9);}
       
          

        wallMaterial = new BABYLON.StandardMaterial("wallMat", scene);
        wallMaterial.diffuseColor = new BABYLON.Color3(1, 1, 1);
        wallMaterial.roughness=0;
        wallMaterial.specularColor = new BABYLON.Color3(0.1, 0.1, 0.1); // weniger Glanz
        
      if(selection.Ambience=="Dark"){wallMaterial.specularPower = 64;}else{
        wallMaterial.specularPower = 0;
      } // glatterer Glanzpunkt

        const floorMaterial = new BABYLON.StandardMaterial("floorMat", scene);
        var  texture = new BABYLON.Texture("https://cdn.shopify.com/s/files/1/0568/2806/8035/files/floor.webp?v=1752150856", scene);

        floorMaterial.diffuseTexture =  texture;
        //floorMaterial.specularColor = new BABYLON.Color3(0.1, 0.1, 0.1);

      

        // Maße
        var wallWidth = 0.01*(screenwidth+150);
        console.log(wallWidth);
        var wallHeight = 0.01*(gesamthöhe+150);
        var wallDepth = 0.01;


        // Setze interface mit beschränkungen
          roomHeight.value=parseInt(gesamthöhe)+150;
          roomWidth.value=parseInt(screenwidth)+150;
        //

        var floorWidth = wallWidth;
        var floorLength = wallWidth + wallDepth;
        // Hauptwand (Front)
         mainWall = BABYLON.MeshBuilder.CreateBox("mainWall", {
            width: 1,
            height: 1,
            depth: 0.01
        }, scene);
        //mainWall.position = new BABYLON.Vector3(0, -3, 0);
        mainWall.material = wallMaterial;
        mainWall.setPivotPoint(new BABYLON.Vector3(0, -1 / 2, 0));

        // Linke Wand
        const leftWall = BABYLON.MeshBuilder.CreatePlane("floor", {width: 1, height: 1}, scene);

        leftWall.rotation.y = 1.5*Math.PI;
        // position x = -halbe Wandbreite, z = -halbe Wandbreite (links hinten)
        leftWall.position = new BABYLON.Vector3(-1 / 2, 0, -1 / 2);
        leftWall.material = wallMaterial;

        // Rechte Wand
        const rightWall = BABYLON.MeshBuilder.CreatePlane("floor", {width: 1, height: 1}, scene);
        rightWall.rotation.y = Math.PI / 2;
        // position x = +halbe Wandbreite, z = -halbe Wandbreite (rechts hinten)
        rightWall.position = new BABYLON.Vector3(1 / 2, 0, -1 / 2);
        rightWall.material = wallMaterial;

        // Boden als Plane genau passend in den Raum
        // Breite = wallWidth (zwischen linken und rechten Wand-Innenkanten)
        // Länge = wallWidth + Wanddicke (von Frontwand bis Rückseite der Seitenwände)
        // etwas tiefer als Seitenwand Tiefe

        const floor = BABYLON.MeshBuilder.CreatePlane("floor", {width: 1, height: 1}, scene);
        floor.rotation.x = Math.PI / 2; // flach auf Boden
        // positioniert unterhalb der Wände:
        // Y = 0 (Boden)
        // Z = -(floorLength / 2) + Wanddicke/2 (damit es unter Frontwand und zwischen Seitenwänden liegt)
        floor.position = new BABYLON.Vector3(0, -1/2, -1.01 / 2 + 0.01 / 2);
        floor.material = floorMaterial;

        // Parenting
        leftWall.parent = mainWall;
        rightWall.parent = mainWall;
        floor.parent = mainWall;

        
        mainWall.rotation.y=Math.PI;
        mainWall.position.y=-1.75;
        mainWall.position.z=-0.065;

        mainWall.scaling.x=wallWidth;
        mainWall.scaling.y=wallHeight;
         mainWall.scaling.z=3;

      sliderheight.min = gesamthöhe+10;
      sliderheight.max= (100*wallHeight)-20;

        
            if((empty.position.y-((gesamthöhe+5)*0.01))<0){
              console.log("CLIP");
              empty.position.y = 0.01*(gesamthöhe+10);
              screenheightgui(gesamthöhe+10);
            }
          

     }
    
    

//createRoom();
        //Skaliere Raum:
        console.log("TEST");
        document.getElementById("createRoom").addEventListener("click",createRoom);
    //WAND ENDE


    document.getElementById("removeRoom").addEventListener("click",deleteRoom);

    function deleteRoom(){
       roombool=false; 
          mainWall.dispose();
           $('#roomgui').removeClass('panel');
          $('#roomgui').addClass('roomguic');
       document.getElementById("createRoom").style.display="flex";
    }

    document.getElementById("updateRoom").addEventListener("click",updateRoom );

      
     const roomHeight = document.getElementById("roomheight");
  const roomWidth = document.getElementById("roomwidth");

    function updateRoom(){
       
  const roomHeightval =roomHeight.value;
  const roomWidthval = roomWidth.value

      console.log(roomWidthval/screenwidth+100);
          //mainWall.scaling.y = (0.01*roomHeightval)/2.4
 if (
  !isNaN(roomHeightval)
 && roomHeightval >= 220 && roomHeightval <= 600 
 
) {
  mainWall.scaling.y = roomHeightval/100;
  console.log("Raumhöhe:", roomHeightval, "cm");

   sliderheight.max= roomHeightval-20;

 // wenn gesamtgröße >als wand dann färbe leinwand rot, wenn gesamtgröße < wand dann platziere ganz oben
 console.log("G"+gesamthöhe + "roomheight "+ roomHeightval);

  if(selection.Aspect==="r169"){
          checkSize(newInd,16,9);}
    

 if((parseInt(empty.position.y*100))>roomHeightval){
  console.log("clipeprcheck");
    empty.position.y=(sliderheight.max/100);
    screenheightgui(sliderheight.max);
    /*sliderheightVal.innerHTML=sliderheight.max;
    sliderheight.value=sliderheight.max; */
 }else{
 
screenheightgui(parseInt(empty.position.y*100));
 }
  
}else{
  
  alert("Please enter a wall height between 220 cm and 600 cm");

}

 if(!isNaN(roomWidthval) &&  roomWidthval >= 240 && roomWidthval <= 1000){
  mainWall.scaling.x = roomWidthval/100;
  console.log("Raumhöhe:", roomHeightval, "cm");

   sliderheight.max= roomHeightval-20;

 // wenn gesamtgröße >als wand dann färbe leinwand rot, wenn gesamtgröße < wand dann platziere ganz oben
 console.log("G"+gesamthöhe + "roomheight "+ roomHeightval);

   if(selection.Aspect==="r169"){
          checkSize(newInd,16,9);}
         

 if((parseInt(empty.position.y*100))>roomHeightval){
  console.log("clipeprcheck");
    empty.position.y=(sliderheight.max/100);
    screenheightgui(sliderheight.max);
    /*sliderheightVal.innerHTML=sliderheight.max;
    sliderheight.value=sliderheight.max; */
 }else{
 
screenheightgui(parseInt(empty.position.y*100));
 }

 }else{ alert("Please enter a wall width between 240 cm and 1000 cm");}

 
checkScreensize();
 
    }

    var gesamthöhe;
    var screenwidth;

    
      function checkSize(diagonalInInches, ratioWidth, ratioHeight){

      console.log("CHECKSIZE  ")

        var factor = Math.sqrt(ratioWidth ** 2 + ratioHeight ** 2);

        


        //var widthInInches = diagonalInInches * (ratioWidth / factor);
        var heightInInches = diagonalInInches * (ratioHeight / factor);
        console.log("height" + heightInInches);
        
        //  ALTE FORMEL: screenwidth = 264* (diagonalInInches/100); => die 264 sind vom saker wegen der case, die über die leinwand hinausgeht.
        screenwidth = 223* (diagonalInInches/100)*resFactorX;
            console.log("width" + screenwidth);
        var screenheight = heightInInches * 2.54*resFactorX;
        console.log("cm heigth" + screenheight);

         gesamthöhe = parseInt(screenheight);
        console.log("Berechnung: height"+ screenheight );

        //sliderheight.max=gesamthöhe+80;
        sliderheight.min = gesamthöhe+10;

       
        // -> if 

        console.log("Breite: "+ screenwidth);
        console.log("Höhe: "+ gesamthöhe );

        //sliderheight.max= gesamthöhe+80;

      }


      //document.getElementById("checksizing").addEventListener("click",checkSize(newInd,16,9));

      
      function checkScreensize(){
console.log("SCREENSIZE"),
//console.log("Zu Hoch. LW "+gesamthöhe +" Raum:  " +roomHeight.value )
// console.log("Zu Breit. LW "+screenwidth +" Raum:  " +roomWidth.value )
roomnotice.style.display="none";


if(gesamthöhe+20>roomHeight.value){
  console.log("Zu Hoch. LW "+gesamthöhe +" Raum:  " +roomHeight.value )
  roomnotice.style.display="flex";
}

if(screenwidth>roomWidth.value){
 console.log("Zu Breit. LW "+screenwidth +" Raum:  " +roomWidth.value )
  roomnotice.style.display="flex";
}
      }


         // ROOMEND

    
        //scene.debugLayer.show();
        return scene;
      };

      
    
      function startRender(){
      const scene = createScene(); //Call the createScene function
      scene.clearColor = new BABYLON.Color4(0.75, 0.75, 0.75, 1);
      //engine.resize();

      // Register a render loop to repeatedly render the scene
      engine.runRenderLoop(function () {
        scene.render();
      });

      // Watch for browser/canvas resize events
      window.addEventListener("resize", function () {
        engine.resize();
      })
    }

var butAddC = document.getElementById("addCart");
      
            function checkVariantAvailability(variantId) {
  fetch(`/variants/${variantId}.js`)
    .then(res => res.json())
    .then(variant => {
      if (variant.available) {
        console.log('Variante verfügbar ✅');
        butAddC.innerHTML="Add to cart"
        butAddC.classList.remove('disabled');
        butAddC.disabled=false;
        // Hier Button aktivieren
        //document.querySelector('#add-to-cart-button').disabled = false;
      } else {
        console.log('Variante NICHT verfügbar ❌');
        butAddC.innerHTML="Sold out"
       butAddC.disabled=true;
        butAddC.classList.add('disabled');
        // Hier Button deaktivieren
        //document.querySelector('#add-to-cart-button').disabled = true;
      }
    })
    .catch(err => {
      console.error('Fehler beim Prüfen der Variante:', err);
    });
}


  //startRender();
    

      startRender();
    

      document.getElementById("canvas-style").addEventListener("click", startEngine, { once: true })
  document.getElementById("canvas-style").addEventListener("touchstart",startEngine, { once: true });
    
  function startEngine(){
document.getElementById("poster").style.display="none";
  }

    function setGrey(){

           $('.buttonMat').prop('disabled', true).css({
    "background-color": "grey",
    "cursor": "not-allowed"
});

  }